export const CHANGE_SELECTED_ROWDEF = "CHANGE_SELECTED_ROWDEF";
export const CHANGE_ROWDEF_LIST_EMPTY = "CHANGE_ROWDEF_LIST_EMPTY";
export const RESET_ACCOUNTS_STATE = "RESET_ACCOUNTS_STATE";

export const changeSelectedRowDef = (id, name) => ({
  type: CHANGE_SELECTED_ROWDEF,
  payload: {
    rowDefinitionID: id,
    rowDefinitionName: name,
  },
});

export const changeRowDefListEmpty = (empty) => ({
  type: CHANGE_ROWDEF_LIST_EMPTY,
  payload: {
    empty,
  },
});

export const resetAccountsState = () => ({
  type: RESET_ACCOUNTS_STATE,
});
